import DashboardLayout from '../layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../pages/NotFoundPage.vue'

// Admin pages
import Home from 'src/pages/home.vue'
import NewRelic from 'src/pages/newrelic.vue'
import AWS from 'src/pages/aws.vue'
import awsRI from 'src/pages/awsri.vue'
import awsSavingsPlan from 'src/pages/aws_savingsplan.vue'
import Akamai from 'src/pages/Akamai.vue'
import Cloudability from 'src/pages/cloudability.vue'
import Gitlab from 'src/pages/Gitlab.vue'
import Git from 'src/pages/Git.vue'
import LogzIO from 'src/pages/logzio.vue'
import Logstack from 'src/pages/logstack.vue'
//import Datavisor from 'src/pages/datavisor.vue'
import Edrans from 'src/pages/edrans.vue'
import PagerDuty from 'src/pages/pagerduty.vue'
import PagerDutyUsers from 'src/pages/pagerdutyusers.vue'
import Plutus from 'src/pages/teams/plutus.vue'
import SharedCSSUserPack from 'src/pages/teams/shared-css-user-pack.vue'
import Panamera from '@/pages/teams/panamera.vue'
import Reservations from 'src/pages/Reservations.vue'
import UserProfile from 'src/pages/UserProfile.vue'
import Teams from "src/pages/Teams"
import Users from "src/pages/Users"
import UserEdit from "src/pages/Users/Edit"
import TableList from 'src/pages/TableList.vue'
import Typography from 'src/pages/Typography.vue'
import Icons from 'src/pages/Icons.vue'
import TLS from 'src/pages/tls.vue'
// import Maps from 'src/pages/Maps.vue'
import Units from 'src/pages/CustomerUnits/Units.vue'
import Notifications from 'src/pages/Notifications.vue'
import Upgrade from 'src/pages/Upgrade.vue'
import BusinessUnits from 'src/pages/BusinessUnits'
import Data from 'src/pages/BusinessUnits/Data'
import Central from 'src/pages/organizations/Central.vue'
import Europe from 'src/pages/organizations/Europe.vue'
import India from 'src/pages/organizations/India.vue'
import Indonesia from 'src/pages/organizations/Indonesia.vue'
import Latam from 'src/pages/organizations/Latam.vue'
import Mena from 'src/pages/organizations/Mena.vue'
import Ssa from 'src/pages/organizations/Ssa.vue'
import Tier from 'src/pages/tier.vue'
import Vendors from 'src/pages/vendors.vue'
import VendorDetails from 'src/pages/vendor.vue'
import Redirect from 'src/pages/redirect.vue'

// OKTA
import Vue from 'vue'
import Auth from '@okta/okta-vue'
const CALLBACK_PATH = '/implicit/callback'


const devConfig = {
    clientId: '0oa146a610ZCPjT7Z4x7',
    issuer: 'https://dev-948376.okta.com/oauth2/default',
    redirectUri: 'https://localhost:8080/implicit/callback',
    scopes: ['openid', 'profile', 'email'],
    pkce: false
};



//prd s3

const prdConfig = {
    clientId: '0oa4ngqjlkRIEru8t0i7',
    issuer: 'https://olxgroup.okta-emea.com/oauth2/default',
    redirectUri: 'https://dashboard.ceg.olx.org/implicit/callback',
    scopes: ['openid', 'profile', 'email'],
    pkce: false
};

if (process.env.NODE_ENV === 'production') {
    Vue.use(Auth, {...prdConfig })
} else {
    Vue.use(Auth, {...devConfig })
}

let authenticated = true //process.env.NODE_ENV === 'production';

let routes = []

if (window.location.host === 'static.pages.olx.org') {
    routes = [
        { path: '*', component: Redirect }
    ]
} else {
    routes = [
        { path: CALLBACK_PATH, component: Auth.handleCallback() },
        {
            path: '/',
            meta: { requiresAuth: authenticated },
            component: DashboardLayout,
            redirect: '/views/home',
            children: [{
                path: '/views/home',
                name: 'Home',
                meta: { requiresAuth: authenticated },
                component: Home
            }]
        },
        {
            path: '/redirect',
            component: DashboardLayout,
            redirect: '/views/redirect',
            children: [{
                path: '/views/redirect',
                name: 'Redirect',
                component: Redirect
            }]
        },
        {
            path: '/business-units',
            meta: { requiresAuth: authenticated },
            name: 'business-units',
            component: DashboardLayout,
            redirect: '/business-units/data',
            children: [
                /*
                {
                    path: 'business-units/goods',
                    name: 'goods',
                    component: Goods
                },*/
                {
                    path: 'data',
                    meta: { requiresAuth: authenticated },
                    name: 'data',
                    component: Data
                },
                {
                    path: 'plutus',
                    meta: { requiresAuth: authenticated },
                    name: 'plutus',
                    component: Plutus
                },
                {
                    path: 'shared-css-user-pack',
                    meta: { requiresAuth: authenticated },
                    name: 'shared-css-user-pack',
                    component: SharedCSSUserPack
                },
                {
                    path: 'panamera',
                    meta: { requiresAuth: authenticated },
                    name: 'panamera',
                    component: Panamera
                },

            ],
        },
        {
            path: '/views',
            meta: { requiresAuth: authenticated },
            component: DashboardLayout,
            redirect: '/views/aws',
            children: [{
                    path: 'tier/1',
                    props: { tier: 1 },
                    meta: { requiresAuth: authenticated },
                    name: 'Tier1',
                    component: Tier
                },
                {
                    path: 'tier/2',
                    props: { tier: 2 },
                    name: 'Tier2',
                    meta: { requiresAuth: authenticated },
                    component: Tier
                },
                {
                    path: 'tier/3',
                    props: { tier: 3 },
                    name: 'Tier3',
                    meta: { requiresAuth: authenticated },
                    component: Tier
                }, {
                    path: 'tier/4',
                    props: { tier: 4 },
                    name: 'Tier4',
                    meta: { requiresAuth: authenticated },
                    component: Tier
                }, {
                    path: 'aws',
                    name: 'AWS',
                    meta: { requiresAuth: authenticated },
                    component: AWS
                }, {
                    path: 'aws-ri',
                    name: 'AWS Reservation Portfolio',
                    component: awsRI
                }, {
                    path: 'aws-sp',
                    name: 'AWS SavingsPlans Performance',
                    component: awsSavingsPlan
                },
                {
                    path: 'akamai',
                    name: 'Akamai',
                    meta: { requiresAuth: authenticated },
                    component: Akamai
                },
                {
                    path: 'cloudability',
                    name: 'Cloudability',
                    meta: { requiresAuth: authenticated },
                    component: Cloudability
                },
                {
                    path: 'gitlab',
                    name: 'Gitlab Costs Breakdown',
                    meta: { requiresAuth: authenticated },
                    component: Gitlab
                },
                {
                    path: 'git',
                    name: 'Git Costs Breakdown',
                    meta: { requiresAuth: authenticated },
                    component: Git
                },
                {
                    path: 'logstack',
                    name: 'Logstack Costs Breakdown',
                    meta: { requiresAuth: authenticated },
                    component: Logstack
                },
                /*			{
                                path: 'datavisor',
                                name: 'Datavisor usage',
                                component: Datavisor
                            },*/
                {
                    path: 'newrelic',
                    name: 'New Relic',
                    meta: { requiresAuth: authenticated },
                    component: NewRelic
                },
                {
                    path: 'edrans',
                    name: 'Edrans',
                    meta: { requiresAuth: authenticated },
                    component: Edrans
                },
                {
                    path: 'logzio',
                    name: 'LogzIO',
                    meta: { requiresAuth: authenticated },
                    component: LogzIO
                },
                {
                    path: 'tls',
                    name: 'TLS',
                    meta: { requiresAuth: authenticated },
                    component: TLS
                },
                {
                    path: 'pagerduty',
                    name: 'PagerDuty',
                    meta: { requiresAuth: authenticated },
                    component: PagerDuty
                },
                {
                    path: 'pagerduty/users',
                    name: 'PagerDutyUsers',
                    meta: { requiresAuth: authenticated },
                    component: PagerDutyUsers
                },
                {
                    path: 'organizations/central',
                    name: 'central',
                    meta: { requiresAuth: authenticated },
                    component: Central
                },
                {
                    path: 'organizations/europe',
                    name: 'europe',
                    meta: { requiresAuth: authenticated },
                    component: Europe
                },
                {
                    path: 'organizations/india',
                    name: 'india',
                    meta: { requiresAuth: authenticated },
                    component: India
                },
                {
                    path: 'organizations/indonesia',
                    name: 'indonesia',
                    meta: { requiresAuth: authenticated },
                    component: Indonesia
                },
                {
                    path: 'organizations/latam',
                    name: 'latam',
                    meta: { requiresAuth: authenticated },
                    component: Latam
                },
                {
                    path: 'organizations/mena',
                    name: 'mena',
                    meta: { requiresAuth: authenticated },
                    component: Mena
                },
                {
                    path: 'organizations/ssa',
                    name: 'ssa',
                    meta: { requiresAuth: authenticated },
                    component: Ssa
                },
                {
                    path: 'vendors',
                    meta: { requiresAuth: authenticated },
                    name: 'vendors',
                    component: Vendors
                },
                {
                    path: 'profile',
                    name: 'user profile',
                    component: UserProfile,
                    meta: { requiresAuth: authenticated },

                },
                {
                    path: 'teams',
                    name: 'Teams',
                    component: Teams,
                    meta: { requiresAuth: authenticated },

                },
                {
                    path: 'users',
                    name: 'Users',
                    component: Users,
                    meta: { requiresAuth: authenticated },
                },
                {
                    path: 'user/edit/:userId',
                    name: 'User Edit',
                    component: UserEdit,
                    meta: { requiresAuth: authenticated },
                },
                {
                    path: 'vendor/:vendorId',
                    meta: { requiresAuth: authenticated },
                    component: VendorDetails,
                    props: true
                },
                {
                    path: 'customer-units/:unit',
                    meta: { requiresAuth: authenticated },
                    component: Units,
                    props: true
                },
            ]
        },
        { path: '*', component: NotFound }
    ]
}
/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes